import React from "react";

import styles from "./styles/Dashboard.module.scss";

import { Col, Row } from "react-bootstrap";
import { SubTitle } from "../../Components/CustomComponents";
// import MatchCard from '../../Components/Cards/MatchCard';
// import TournamentCard from '../../Components/Cards/TournamentCard';
import { FaUsers } from "react-icons/fa";
import { FaUserNurse } from "react-icons/fa6";
import { GiBabyfootPlayers, GiTeamDowngrade } from "react-icons/gi";
import { RiParentFill } from "react-icons/ri";
import { TbTournament } from "react-icons/tb";
import DashboardCard from "../../Components/Cards/DashboardCard";
import { useGetDashboardQuery } from "../../Data/services/dashboardApi";
import { ROUTES } from "./constants";
import GrowSpinner from "../../Components/CustomComponents/GrowSpinner";

export default function Dashboard({ setPage }) {
  let bg1 = "#FFFFFF";
  let bg2 = "#FFFFFF";
  let iconColor = "8280FF";
  const { data, isLoading, isFetching } = useGetDashboardQuery();

  const handleViewLiveMatches = () => {
    setPage(ROUTES.LIVE_MATCHES);
  };

  const handleViewTournament = () => {
    setPage(ROUTES.TOURNAMENTS);
  };

  const cardData = [
    {
      icon: <FaUserNurse color={iconColor} />,
      number: isLoading ? <GrowSpinner /> : data?.data?.total_routes,
      text: "Total Routes",
    },
    {
      icon: <RiParentFill color={iconColor} />,
      number: isLoading ? <GrowSpinner /> : data?.data?.total_supervisor,
      text: "Total Supervisor",
    },
    {
      icon: <RiParentFill color={iconColor} />,
      number: isLoading ? <GrowSpinner /> : data?.data?.total_users,
      text: "Total User",
    },
  ];
  return (
    <div className={styles.Dashboard}>
      <div className={styles.headerContainer}>
        <div className={styles.titleContainer}>
          <SubTitle text={"Dashboard"} />
        </div>
      </div>
      <Row className={`${styles.matchRow} w-100 mt-2 mb-5`}>
        {cardData.map((card, index) => (
          <Col key={index} className="mt-2 mb-2" lg={4} md={4} sm={6}>
            <DashboardCard
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number}
              text={card.text}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
